import React, { useEffect } from 'react';
import FlexibleDatesRepricingMessageDecorator, {
  FlexibleDatesRepricingMessagePositionType,
} from '@components/Results/Components/FlexibleDates/FlexibleDatesRepricingMessage/FlexibleDatesRepricingMessageDecorator';
import { useItinerary } from '@components/Results/Components/Itinerary/Provider';
import { HighlightedType } from '@components/Results/Components/ItineraryHeader/constants/highlightedTypes';
import { Card } from '@edreamsodigeo/prisma-design-system';
import PrimeDayItineraryHeaderRevamp from '@components/Results/Components/ThreeColumnsItinerary/Campaigns/PrimeDay/PrimeDayItineraryHeader';
import HighlightedDecorator from '@components/Results/Components/ThreeColumnsItinerary/HighlightedDecorator/HighlightedDecorator';
import { useFlightOfTheDayTracking } from '@components/Results/Components/Itinerary/useFlightOfTheDayTracking';
import { useFlightOfTheDayItineraryIds } from 'clientState/providers/SearchResponseProvider';

const ThreeColumnsItineraryDecorationRevamp = ({
  Component,
  highlightedType,
  hasRetailingTechniques,
  withPrimeDayHeader,
  type,
  sx,
  children,
  itinerary,
  position,
  ...props
}) => {
  const { trackFlightOfTheDay } = useFlightOfTheDayTracking('show');
  const flightOfTheDayItineraryIds = useFlightOfTheDayItineraryIds();
  const { id } = useItinerary();
  const isFlightOfTheDay =
    (flightOfTheDayItineraryIds.includes(id) &&
      highlightedType !== HighlightedType.Recommended &&
      highlightedType !== HighlightedType.Personalised) ||
    highlightedType === HighlightedType.FlightOfTheDay;

  useEffect(() => {
    if (isFlightOfTheDay) {
      trackFlightOfTheDay(itinerary, position, hasRetailingTechniques);
    }
  }, [
    isFlightOfTheDay,
    hasRetailingTechniques,
    itinerary,
    position,
    trackFlightOfTheDay,
  ]);

  let CardComponent = Component;

  if (isFlightOfTheDay && hasRetailingTechniques) {
    highlightedType = HighlightedType.FlightOfTheDay;
    CardComponent = Card;
  }

  return (
    <FlexibleDatesRepricingMessageDecorator
      position={FlexibleDatesRepricingMessagePositionType.belowCard}
    >
      {withPrimeDayHeader &&
        highlightedType !== HighlightedType.FlightOfTheDay && (
          <PrimeDayItineraryHeaderRevamp />
        )}
      <HighlightedDecorator
        CardComponent={CardComponent}
        type={type}
        highlightedType={highlightedType}
        {...props}
        sx={sx}
      >
        {children}
      </HighlightedDecorator>
    </FlexibleDatesRepricingMessageDecorator>
  );
};

export default ThreeColumnsItineraryDecorationRevamp;
